export default "/assets/thumbs_up-5e6e1b46fc08b78ba44be974aa9d85e51e49da1eacb6a4270d7059520323bf44.svg";